import React from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  CardActions,
  SvgIcon,
} from '@mui/material';
import { OutlinedIcons } from '@marageti/z4-lib';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';

const { OutlinedArrowSmRightIcon } = OutlinedIcons;

const ArchivedTripsButton = ({ archivedTrips }: { archivedTrips: TripRequest[] }) => (
  <Card variant="outlined">
    <CardHeader title="Archived Trips" />
    <CardContent>
      <Typography variant="body">Declined or unmatched requests.</Typography>
    </CardContent>
    <CardActions>
      <Link
        to="/archived-trips"
        state={{ archivedTrips }}
        style={{
          color: 'inherit', textDecoration: 'none', display: 'flex', alignItems: 'center',
        }}
      >
        <Typography variant="h4">
          View Archived Trips
        </Typography>
        <SvgIcon sx={{ ml: 1 }}>
          <OutlinedArrowSmRightIcon />
        </SvgIcon>
      </Link>
    </CardActions>
  </Card>
);

export default ArchivedTripsButton;
